/* /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/lang/en.lyaml */
hns('I18n', {
  "translations": {
    "en": {
      "default": {
        "firstName": "Unknown",
        "lastName": "Visitor",
        "messageName": "Default Message",
        "meetingsLinkText": "Schedule some time with me",
        "repText": "Hi there! Let me know if you have any questions about the product or pricing.",
        "visitorText": "Can you go into a bit more detail about your pricing structure?",
        "awayMessage": "We're away for the moment, but let us know if you have any questions and we'll reply to you soon.",
        "initialMessage": "Have any questions? Happy to help!"
      }
    }
  },
  "translationsLoaded": {
    "conversations-schema": {
      "en": "static-1.79"
    }
  },
  "translationsAvailable": {
    "conversations-schema": {
      "de": "static-1.79",
      "en": "static-1.79",
      "es": "static-1.79",
      "fr": "static-1.79",
      "ja": "static-1.79",
      "pt-br": "static-1.79"
    }
  }
});
if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-schema:en', {version: 'static-1.79'}); }

/* /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/lang/en.lyaml */
hns('I18n', {
  "translations": {
    "en": {
      "loadingState": {
        "header": "Loading messages"
      },
      "unknownVisitor": "Unknown visitor",
      "blockedVisitorBanner": {
        "title": "Visitor is blocked.",
        "content": "This visitor can no longer send you messages."
      },
      "blockVisitorDeletePrompt": {
        "header": "Are you sure you want to unblock this visitor?",
        "description": "Remove this visitor from your blocked list to allow future messages from them.",
        "buttons": {
          "unblock": "Yes, unblock",
          "cancel": "Cancel"
        }
      },
      "chat": {
        "thisVisitor": "This visitor",
        "zeroState": {
          "STARTED": {
            "title": "You don't have any open chats right now",
            "description": "Keep this window open to stay online and receive notifications when your next live chat begins"
          },
          "ENDED": {
            "title": "You don't have any closed chats right now",
            "description": "Keep this window open to stay online and receive notifications when your next live chat begins"
          },
          "BLOCKED": {
            "title": "You don't have any blocked visitors",
            "description": "Block visitors whose messages you don't want to receive with the actions menu. Select the conversation you would like to block to reveal the menu on the right of your screen."
          },
          "customMessage": "Create a custom message to invite website visitors to chat with you live.",
          "createMessage": "Create message"
        }
      },
      "alerts": {
        "PERMISSION_RETRY_FAILED": {
          "title": "Retry Failed",
          "description": "Please click \"{{ helpLink }}\" for help."
        },
        "EDIT_SUCCEEDED": {
          "title": "Changes saved",
          "description": "Edits to your message have been saved"
        },
        "EDIT_FAILED": {
          "title": "Save Error",
          "description": "Edits to your message could not be saved"
        },
        "SETTINGS": {
          "title": "Changes saved",
          "description": "Settings have been saved"
        },
        "NEW_MESSAGE": {
          "title": {
            "one": "You have {{ count }} new message.",
            "other": "You have {{ count }} new messages."
          },
          "description": "Open conversation"
        },
        "EMBED_CODE_EMAIL": {
          "title": "Email sent",
          "description": "The embed code has been sent to {{ email }}"
        },
        "pubNubStatus": {
          "visiblyOffline": {
            "title": "A network connection issue has occurred.",
            "description": "Unable to connect you to messages. Please check your internet connection and try <a href=\"javascript:document.location.reload(true)\">refreshing your page</a>."
          },
          "PNNetworkUpCategory": {
            "title": "Network issue resolved.",
            "description": "You have been reconnected to messages."
          }
        }
      },
      "default": {
        "repText": "Hi there! Let me know if you have any questions about the product or pricing.",
        "initialMessage": "Have any questions? Happy to help!",
        "meetingsLinkText": "Schedule some time with me",
        "askForEmailMessage": "Don’t have time to wait for a response? Leave your email to get notified when we reply."
      },
      "input": {
        "chatButtons": {
          "insertLabel": "Insert:",
          "snippetsButton": "Snippet"
        },
        "chatArea": {
          "branding": "Not using {{ messagesLink }} yet?",
          "messages": "Messages"
        },
        "chatTextArea": {
          "validationMessage": "Message is too long.",
          "placeholder": "Write a message",
          "offlinePlaceholder": "Network issue detected."
        },
        "emailCapture": {
          "header": "Enter your email to get notified of a reply.",
          "placeholder": "Enter email address",
          "offlineSuccess": "Thanks! {{ name }} will respond by email.",
          "onlineSuccess": "Thanks! If you have to leave this chat, we'll email you."
        },
        "email": {
          "error": "You entered an invalid email."
        },
        "embedCodeInputSelector": {
          "link": "How do I install the tracking code?"
        },
        "embedCodeEmailForm": {
          "title": "Need someone else to install the code?",
          "description": "Email the code snippet to your web developer or admin.",
          "placeholder": "Enter email address",
          "error": "Please enter a valid email address."
        },
        "widgetCustomization": {
          "tooltip": {
            "text": "Your avatar can be updated in your {{ link }}",
            "link": "HubSpot Profile Settings.",
            "preview": "Preview"
          },
          "header": {
            "launcher": "Closed launcher style"
          },
          "switch": {
            "open": "Open",
            "closed": "Closed",
            "preview": "Preview"
          }
        },
        "brandColorPicker": {
          "tip": "Or choose a custom color"
        },
        "launcherPicker": {
          "use": "use {{ type }}",
          "types": {
            "AVATAR": "avatar",
            "ICON": "icon"
          }
        }
      },
      "buttons": {
        "open": "Open <b>({{ count }})</b>",
        "closed": "Closed <b>({{ count }})</b>",
        "blocked": "Blocked <b>({{ count }})</b>",
        "back": "Back to Messages",
        "saveChanges": "Save changes",
        "cancel": "Cancel",
        "send": "Send"
      },
      "settings": {
        "pendingChanges": {
          "one": "You've changed {{ count }} setting.",
          "other": "You've changed {{ count }} settings."
        }
      },
      "saveChangesPrompt": {
        "header": "You've made changes",
        "body": "Save your work now to keep the changes you've made.",
        "button": {
          "positive": "Save",
          "negative": "Don't Save"
        }
      },
      "navContent": {
        "BLOCKING": {
          "header": "Visitor Blocking",
          "description": "Blocked visitors are not able to send you messages through the chat widget on your website."
        },
        "AVAILABILITY": {
          "header": "Availability",
          "description": "Select when you would like to be shown as online and offline."
        },
        "AWAY_MESSAGE": {
          "header": "Offline Message",
          "description": "Customize your offline message to let visitors know you are away at the moment."
        },
        "PROFILE": {
          "header": "My profile",
          "description": "Remember, your avatar will be public in your messages chat window."
        },
        "APPEARANCE": {
          "header": "Appearance",
          "description": "Customize the appearance of your chat window to match your brand."
        },
        "NOTIFICATIONS": {
          "header": "Notifications"
        },
        "TARGET_AUDIENCE": {
          "header": "Target Audience",
          "description": "Select who should see this message, and when."
        },
        "MESSAGE": {
          "header": "Welcome Message",
          "description": "Prompt your visitors to ask you a question or book a meeting."
        },
        "EMBED_CODE": {
          "header": "Install code snippet",
          "description": "Embed this javascript snippet immediately before the end of the body tag on any page you want to display a message. If you are a marketing customer using the HubSpot COS, you can install it in your <a href='https://knowledge.hubspot.com/articles/kcs_article/reports/how-do-i-install-the-hubspot-tracking-code-on-my-website'>Site Footer HTML.</a>"
        },
        "MESSAGE_ROUTING": {
          "header": "Message Routing",
          "description": "Select who should receive incoming chats from this message."
        }
      }
    }
  },
  "translationsLoaded": {
    "conversations-core": {
      "en": "static-1.139"
    }
  },
  "translationsAvailable": {
    "conversations-core": {
      "de": "static-1.139",
      "en": "static-1.139",
      "es": "static-1.139",
      "fr": "static-1.139",
      "ja": "static-1.139",
      "pt-br": "static-1.139"
    }
  }
});
if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-core:en', {version: 'static-1.139'}); }

/* /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/lang/en.lyaml */
hns('I18n', {
  "translations": {
    "en": {
      "uiAddonAvatars": {
        "defaultUploader": {
          "title": "Upload a photo",
          "confirm": "Confirm",
          "cancel": "Cancel",
          "alerts": {
            "imageTooBig": {
              "title": "File too big",
              "text": "Please upload a smaller one"
            },
            "apiError": {
              "title": "Something went wrong",
              "text": "Please try again later"
            }
          }
        }
      },
      "ui": {
        "UIErrorMessage": {
          "error": {
            "title": "All is not lost."
          },
          "notFound": {
            "title": "All who wander are not lost."
          },
          "badRequest": {
            "title": "Goodness gracious."
          },
          "expired": {
            "title": "We're sorry."
          }
        },
        "time": {
          "today": "Today at {{time}}",
          "yesterday": "Yesterday at {{time}}",
          "datetime": "{{date}} at {{time}}"
        }
      },
      "salesUI": {
        "UIAbstractDateInput": {
          "invalidDate": "Invalid date",
          "dateBelowMin": "You must choose a newer date",
          "dateAboveMax": "You must choose an older date"
        },
        "UIAbstractNumberInput": {
          "invalidNumber": "Invalid number"
        },
        "UIAvatarHoverlay": {
          "text": "Change photo"
        },
        "UIChangeArrow": {
          "decrease": "Decrease of ",
          "increase": "Increase of "
        },
        "UICopyInput": {
          "label": "Copy",
          "title": "Copy to clipboard",
          "tooltipCopied": "Copied"
        },
        "UIConfirm": {
          "defaultConfirm": "Yes",
          "defaultReject": "No"
        },
        "UICloseButton": {
          "label": "Close"
        },
        "UIDateRangePicker": {
          "placeholder": "Select a range",
          "rangeType": {
            "ALL": "All time",
            "THIS_DAY": "Today",
            "LAST_DAY": "Yesterday",
            "THIS_WEEK": "This week",
            "LAST_WEEK": "Last week",
            "THIS_MONTH": "This month",
            "LAST_MONTH": "Last month",
            "LAST_THIRTY_DAYS": "Last 30 days",
            "LAST_THREE_MONTHS": "Last 3 months",
            "THIS_QUARTER": "This quarter",
            "LAST_QUARTER": "Last quarter",
            "THIS_YEAR": "This year",
            "LAST_YEAR": "Last year",
            "CUSTOM": "Custom time period"
          }
        },
        "UIDateRangeInputs": {
          "invalidDateRange": "Please select an end date that isn't before the given start date"
        },
        "UIDropdownSelect": {
          "placeholder": "No value selected"
        },
        "UIEditableControls": {
          "cancel": "Cancel",
          "save": "Save"
        },
        "UIExpandableText": {
          "collapseButtonText": "See less",
          "expandButtonText": "See more"
        },
        "UIFileInput": {
          "defaultChangeLabel": "Change file",
          "defaultSelectLabel": "Choose file"
        },
        "UIHelpButton": {
          "clickForHelp": "Click for help"
        },
        "UIIconRating": {
          "ariaValueText": "{{value}} of {{maxValue}}"
        },
        "UILink": {
          "externalTitle": "Link opens in a new window"
        },
        "UILoading": {
          "title": "Loading…"
        },
        "UILockBadge": {
          "title": "This feature is locked"
        },
        "UIPaginator": {
          "label": "Pagination",
          "pageNumber": {
            "currentIndicator": "You are currently on ",
            "description": "Page "
          },
          "firstPage": {
            "label": "First",
            "description": "First page"
          },
          "previousPage": {
            "label": "Prev",
            "description": "Previous page"
          },
          "nextPage": {
            "label": "Next",
            "description": "Next page"
          },
          "lastPage": {
            "label": "Last",
            "description": "Last page"
          }
        },
        "UINumberRating": {
          "lowRangeLabel": "Strongly disagree",
          "highRangeLabel": "Strongly agree"
        },
        "UISearchableSelectInput": {
          "placeholder": "Search"
        },
        "UISearchInput": {
          "placeholder": "Search",
          "minimumSearchMessage": {
            "one": "Type 1 more character",
            "other": "Type {{count}} more characters"
          }
        },
        "UISelect": {
          "allOptionsSelected": "All options are selected",
          "createOption": "Create option “{{label}}”",
          "andMore": "…and {{count}} more.",
          "loadMore": "Load more",
          "loading": "Loading…",
          "noResults": "No results found",
          "placeholder": "Search"
        },
        "UISelectableBox": {
          "checkboxLabel": "Is Selected",
          "radioLabel": "Is Selected"
        },
        "UITableSortToggle": {
          "ascendingSort": "Ascending sort",
          "descendingSort": "Descending sort",
          "noSort": "No sort"
        },
        "UITabs": {
          "moreDropdownLabel": "More"
        },
        "UITeaseNotification": {
          "optionsButtonTooltipText": "Show options"
        },
        "UITextArea": {
          "characterCounter": {
            "one": "{{count}} character",
            "other": "{{count}} characters"
          }
        },
        "UITimePicker": {
          "placeholder": "Select a time"
        },
        "UIToggle": {
          "checkedLabel": "on",
          "uncheckedLabel": "off"
        },
        "UITypeahead": {
          "noMatchesFound": "No matches found",
          "noOptions": "None"
        },
        "UIWizard": {
          "back": "Back",
          "cancel": "Cancel",
          "done": "Done",
          "next": "Next",
          "stepCount": "Step {{stepNumber}} of {{stepCount}}"
        },
        "XSSTooltip": {
          "explanation": "This link has been disabled for your security."
        }
      }
    }
  },
  "translationsLoaded": {
    "UIComponents": {
      "en": "static-2.348"
    }
  },
  "translationsAvailable": {
    "UIComponents": {
      "de": "static-2.348",
      "en": "static-2.348",
      "es": "static-2.348",
      "fr": "static-2.348",
      "ja": "static-2.348",
      "pt-br": "static-2.348"
    }
  }
});
if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-2.348'}); }

/* /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/lang/en.lyaml */
hns('I18n', {
  "translations": {
    "en": {
      "chat": {
        "urlMarker": "<b>Chatting from:</b> {{url}}",
        "visitorAway": "{{ visitorName }} left the page and may not see new messages right away.",
        "closedConversation": "Conversation closed on {{ endedTime }}",
        "status": {
          "PUBLISHED": "Sent ",
          "UNPUBLISHED": "Sending... ",
          "PUBLISH_FAILED": "Not delivered. Click to retry."
        }
      }
    }
  },
  "translationsLoaded": {
    "ui-addon-conversations": {
      "en": "static-1.133"
    }
  },
  "translationsAvailable": {
    "ui-addon-conversations": {
      "de": "static-1.133",
      "en": "static-1.133",
      "es": "static-1.133",
      "fr": "static-1.133",
      "ja": "static-1.133",
      "pt-br": "static-1.133"
    }
  }
});
if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:ui-addon-conversations:en', {version: 'static-1.133'}); }

/* /usr/share/hubspot/build/workspace/LiveMessagesUI/conversations-visitor-ui/static/lang/en.lyaml */
hns('I18n', {
  "translations": {
    "en": {
      "conversations-visitor": "BethBot requires that at least one key be defined in this file"
    }
  },
  "translationsLoaded": {
    "conversations-visitor-ui": {
      "en": "static-1.58"
    }
  },
  "translationsAvailable": {
    "conversations-visitor-ui": {
      "de": "static-1.58",
      "en": "static-1.58",
      "es": "static-1.58",
      "fr": "static-1.58",
      "ja": "static-1.58",
      "pt-br": "static-1.58"
    }
  }
});
if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-visitor-ui:en', {version: 'static-1.58'}); }

/* /usr/share/hubspot/build/workspace/LiveMessagesUI/conversations-visitor-ui/static/bundles/visitor-before.js */






//////////////////
// WEBPACK FOOTER
// ../~/bender-webpack/lib/no-parse-loader.js!../~/bender-webpack/lib/sporks/loader.js!./bundles/visitor-before.js
// module id = 612
// module chunks = 